/* eslint-disable */
import materialUI from "material-UI";
import styled from "styled-components";

export const Container = styled.div`
  border-radius: 4px;
  border: 1px solid #ececec;
  display: flex;
  flex-direction: column;
  margin: 0 0 16px 0;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: space-between;
`;

export const ColumnFull = styled.div`
  display: flex;
  flex-direction: column;
  align-items: space-between;
  flex: 1;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const MainRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 51.85px;
  padding: 17.92px 24px 17.92px 21px;
`;

export const SharedContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 21px 16.5px 16.5px 16.5px;
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 1px;
  background: #ececec;
`;

export const Text = styled.p`
  font-family: Inter;
  color: #333;
`;

export const Title = styled.p`
  font-family: Inter;
  color: #646363;
  font-size: 16px;
`;

export const SharedItem = styled.div`
  border-radius: 4px;
  height: 56px;
  align-items: center;
  border: 1px solid #ececec;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 8px 0 0 0;
  padding: 32px 32px 32px 8px;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 51px;
  width: 100%;
`;

interface Props {
  show: any;
}

export const FooterContainer = styled.div<Props>`
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
  height: 80px;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #ececec;
  display: ${(props) => (props.show ? "auto" : "none")};
  z-index: 99;
`;

export const Button = styled(materialUI.Button)`
  padding: 24px;
  background-color: #f43636;
  margin-top: 16px;
  color: #ffffff;
  width: 92%;
  height: 48px;
  &:hover {
    background-color: #f55050;
  }
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px;
`